import { useLocalization } from '~/framework';
import {
   getCourseAssignmentIndividualSummaryDetailsFromClient,
   GetCourseAssignmentIndividualSummaryDetailsError,
} from '~/pages/api/courses/manage/people/user-summaries/getCourseAssignmentIndividualSummaryDetails.api';
import { useQuery } from '@tanstack/react-query';
import { useApiErrorMessageToast } from '~/pages/_shared';

const KEY = 'course-assignments-individual-summary';

export function getCourseAssignmentIndividualSummaryDetailsKey() {
   return [KEY];
}

export function useCourseAssignmentIndividualSummaryDetails(userid: number | null) {
   const { _js } = useLocalization();

   const { handleErrorOrRedirectToLogin } =
      useApiErrorMessageToast<GetCourseAssignmentIndividualSummaryDetailsError>({
         'course_assignments.get_individual_summary_details_.user_not_found': _js(
            'Could not find selected user'
         ),
         default: _js('Something went wrong while retrieving user details. Please try again'),
      });

   return useQuery(
      [KEY, userid],
      async () => {
         if (userid === null) return null;
         return await getCourseAssignmentIndividualSummaryDetailsFromClient(userid);
      },
      {
         onError: handleErrorOrRedirectToLogin,
      }
   );
}
